import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { CartItem, Category, Files, Tag } from 'src/app/models';

@Injectable({
  providedIn: 'root',
})
export class FileHttpService {
  readonly http = inject(HttpClient);

  public createTag(tag) {
    return this.http.post<Tag>('/tags', tag);
  }

  public getTags() {
    return this.http.get<Tag[]>('/tags');
  }

  public deleteTag(id: number) {
    return this.http.delete(`/tag/${id}`);
  }

  public editTag(id, tag) {
    return this.http.put(`/tags/${id}`, { tag });
  }

  public getCategories() {
    return this.http.get<Category[]>('/categories');
  }

  public addCategory(payload: Category) {
    return this.http.post('/categories', payload);
  }

  public updateCategory(id, payload: Category) {
    return this.http.put(`/categories/${id}`, payload);
  }

  public getTagsFiltered(filterTags) {
    return this.http.get<Tag[]>(`/tags_filtered/${filterTags}`);
  }

  public createFileDetails(fileDetails) {
    return this.http.post('/file_details', fileDetails);
  }

  public getPrivateFileDetails(uuid: string) {
    return this.http.get<Files>(`/file_details/${uuid}`);
  }

  public updateFileDetails(id, fileDetails) {
    return this.http.put(`/file_detail/${id}`, fileDetails);
  }

  public getFileDetails(id) {
    return this.http.get<Files>(`/file_detail/${id}`);
  }

  public getRecentFiles(currentLength = 0) {
    return this.http.get<Files[]>(`/recent_files/${currentLength}`);
  }

  public downloadZip(payload: { files: number[] }) {
    return this.http.post<any>('/download_zip', payload, {
      responseType: 'blob' as any,
    });
  }

  public downloadGalleryAsZip(key) {
    return this.http.get<any>(`/download_zip/${key}`, {
      responseType: 'blob' as any,
    });
  }

  public getExternalFiles(key) {
    return this.http.get<CartItem[]>(`/external_files/${key}`);
  }

  public deleteFileDetailsBySourceName(sourceName, sourceId) {
    return this.http.delete(
      `/file_detail_delete_by_sourcename/${sourceName}/${sourceId}`
    );
  }

  public searchFiles(search) {
    return this.http.post<Files>('/file_search', search);
  }

  public createFilesGallery(files) {
    return this.http.post('/generate_gallery', files);
  }

  public searchFilesBySource(search) {
    return this.http.post<Files[]>('/files_by_source', search);
  }
}
